<p-toast></p-toast>

<div
  class="container"
  *ngIf="searched && data && data.length > 0; else noResultsFound"
>
  <div class="styled-text-wrapper">
    <span class="styled-text">{{ searchQueryGrid }}</span>
  </div>

  <div class="main-content" *ngFor="let item of data; let i = index">
    <div
      class="card"
      [ngClass]="{ expanded: expandedCards[i], collapsed: !expandedCards[i] }"
    >
      <div *ngIf="i % 1 === 0" class="route-label-container">
        <div class="line"></div>
        <div class="route-label">
          Litigation
          {{
            currentPage_technical === 1
              ? i + 1
              : (currentPage_technical - 1) * (currentRow_technical || 15) +
                i +
                1
          }}
        </div>

        <div class="line"></div>
      </div>
      <section class="product-info" id="productinfo">
        <h4
          style="
            font-weight: 800;
            font-size: 20px;
            color: #388e3c;
            margin-bottom: 50px;
            text-align: left;
            background: #7bc32e;
            -webkit-background-clip: text;
            color: transparent;
            text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1),
              -2px -2px 5px rgba(0, 0, 0, 0.1);
            letter-spacing: 1px;
            transition: color 0.3s ease, text-shadow 0.3s ease;
          "
        >
          {{ item.activeIngredientBiologicsCombination || "-" }}
          <button
            class="copy-btn"
            *ngIf="item.activeIngredientBiologicsCombination"
            (click)="copyToClipboard(item.activeIngredientBiologicsCombination)"
            pTooltip="Copy to clipboard"
            tooltipPosition="top"
          >
            <i class="pi pi-copy"></i>
          </button>
        </h4>
        <!-- Chemical Structure Image -->
        <!-- <div class="product-container2">
          Left Side: Chemical Structure
          <div class="chemical-structure2" *ngIf="item.routeOfSynthesis">
            <h2>Chemical Structure</h2>
            <div class="image-container2">
              <img
                class="inventor-logo"
                *ngIf="item.routeOfSynthesis"
                [src]="
                  'https://www.chemrobotics.com/agropat/images/route_of_synthesis/' +
                  item.routeOfSynthesis
                "
                alt="Inventor Logo"
              />
            </div>
            <button class="view-btn2" (click)="openGalleria(item)">
              <i class="pi pi-search"></i>
            </button>
          </div>

          Right Side: Product Information
          <div class="product-info-container2">
            <div class="product-info2" *ngIf="item.gbrn">
              <h6>
                GBRN
                <button
                  class="copy-btn2"
                  (click)="copyToClipboardFormattedDate(item.gbrn)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              {{ item.gbrn }}
            </div>
            <div class="product-info2" *ngIf="item.trrn">
              <h6>
                TRRN
                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.trrn)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.trrn || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="item.activeIngredient">
              <h6>
                ACTIVE INGREDIENT
                <button
                  class="copy-btn2"
                  *ngIf="item.activeIngredient"
                  (click)="copyToClipboard(item.activeIngredient)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.activeIngredient || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="item.activeIngredientCasRn">
              <h6>
                CAS RN
                <button
                  class="copy-btn2"
                  *ngIf="item.activeIngredientCasRn"
                  (click)="copyToClipboard(item.activeIngredientCasRn)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.activeIngredientCasRn || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="item.fieldOfApplication">
              <h6>
                FIELD OF APPLICATION
                <button
                  class="copy-btn2"
                  *ngIf="item.fieldOfApplication"
                  (click)="copyToClipboard(item.fieldOfApplication)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.fieldOfApplication || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="item.companyName">
              <h6>
                COMPANY NAME
                <button
                  class="copy-btn2"
                  *ngIf="item.companyName"
                  (click)="copyToClipboard(item.companyName)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>{{ item.companyName || "-" }}</p>
              <div class="logos-images">
                <img
                  style="width: 100px"
                  *ngIf="item.companyLogo; else placeholder"
                  [src]="
                    'https://www.chemrobotics.com/agropat/images/innovators_logo/' +
                    item.companyLogo
                  "
                  alt="Inventor Logo"
                  class="inventor-logo"
                  (error)="onImageError($event)"
                />
                <ng-template #placeholder>
                  <span style="width: 300px; display: inline-block"
                    >INVENTOR LOGO</span
                  >
                </ng-template>
              </div>
            </div>
          </div>
        </div> -->

        <!-- Bootstrap Modal for Full Image View -->
        <p-galleria
          [value]="galleriaImages"
          [(visible)]="displayGalleria"
          [containerStyle]="{ 'max-width': '100%' }"
          [numVisible]="1"
          [circular]="true"
          [fullScreen]="true"
          [showItemNavigators]="false"
          [showThumbnails]="false"
        >
          <ng-template pTemplate="item" let-item>
            <!-- Modal Background (Click to Close) -->
            <div class="modal-overlay" (click)="closeGalleria($event)">
              <div class="image-wrapper" (click)="$event.stopPropagation()">
                <!-- Zoom Controls Positioned at the Top Right -->
                <div class="zoom-controls">
                  <button (click)="zoomIn($event)" title="Zoom In">
                    <i class="pi pi-search-plus"></i>
                  </button>
                  <button (click)="zoomOut($event)" title="Zoom Out">
                    <i class="pi pi-search-minus"></i>
                  </button>
                  <button class="close-button" (click)="closeGalleria($event)">
                    ×
                  </button>
                </div>

                <!-- Scrollable Image Container -->
                <div class="zoom-container">
                  <img
                    [src]="item.itemImageSrc"
                    [style.transform]="'scale(' + zoomLevel + ')'"
                    class="zoomable-image"
                  />
                </div>
              </div>
            </div>
          </ng-template>
        </p-galleria>

        <div class="logos" id="contentToExport3">
          <!-- <h3 class="logos-title">Innovators' Logos</h3> -->
          <!-- Title remains above images -->
          <!-- inventorLogo -->

          <!-- <div class="result-header">
      <h6 style="margin-top: 8px">
        {{ item.companyLogo || "-" }}
      </h6>
    </div> -->
        </div>

        <div class="product-detail" id="contentToExport1">
          <div class="grid grid-cols-3" style="margin-top: -20px">
            <div class="product-info2" *ngIf="displayMap['gbrn'] && item.gbrn">
              <h6>
                gbrn
                <button class="copy-btn2" (click)="copyToClipboard(item.gbrn)">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.gbrn || "-" }}</p>
            </div>

            <div
              class="product-info2"
              *ngIf="displayMap['patentNumbers'] && item.patentNumbers"
            >
              <h6>
                patent numbers

                <button
                  class="copy-btn"
                  *ngIf="item.patentNumbers"
                  (click)="copyToClipboard(item.patentNumbers)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.patentNumbers || "-" }}
              </p>
            </div>
            <div
              class="product-info2"
              *ngIf="displayMap['country'] && item.country"
            >
              <h6>
                country
                <button
                  class="copy-btn"
                  *ngIf="item.country"
                  (click)="copyToClipboard(item.country)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.country || "-" }}
              </p>
            </div>
            <div
              class="logos-images"
              *ngIf="displayMap['country'] && item.country"
            >
              <img
                style="width: 100px"
                *ngIf="item.country"
                [src]="
                  'https://www.chemrobotics.com/agropat/images/innovators_logo/' +
                  item.country
                "
                alt="Inventor Logo"
                class="inventor-logo"
                (error)="onImageError($event)"
              />
              <!-- <ng-template #placeholder>
                <span style="width: 300px; display: inline-block"
                  >INVENTOR LOGO</span
                >
              </ng-template> -->
            </div>

            <div
              class="product-info2"
              *ngIf="
                displayMap['jurisdictionPatentOffice'] &&
                item.jurisdictionPatentOffice
              "
            >
              <h6>
                jurisdiction / patent office

                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.jurisdictionPatentOffice)"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.jurisdictionPatentOffice || "-" }}</p>
            </div>

            <!-- <div class="product-info22" *ngIf="item.patentType">
              <h6>
                PATENT OR NON-PATENT TYPE
                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.patentType)"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.patentType || "-" }}</p>
            </div> -->

            <div
              class="product-info2"
              *ngIf="displayMap['defendants'] && item.defendants"
            >
              <h6>
                defendants
                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.defendants)"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.defendants || "-" }}</p>
            </div>
            <div
              class="logos-images"
              *ngIf="displayMap['defendantLogo'] && item.defendantLogo"
            >
              <img
                style="width: 100px"
                *ngIf="item.defendantLogo"
                [src]="
                  'https://www.chemrobotics.com/agropat/images/innovators_logo/' +
                  item.defendantLogo
                "
                alt="Inventor Logo"
                class="inventor-logo"
                (error)="onImageError($event)"
              />
              <!-- <ng-template #placeholder>
                <span style="width: 300px; display: inline-block"
                  >INVENTOR LOGO</span
                >
              </ng-template> -->
            </div>
            <div
              class="product-info2"
              *ngIf="
                displayMap['uniformResourceLocatorUrl'] &&
                item.uniformResourceLocatorUrl
              "
            >
              <h6>
                uniform resource locator url
                <button
                  class="copy-btn"
                  *ngIf="item.uniformResourceLocatorUrl"
                  (click)="copyToClipboard(item.uniformResourceLocatorUrl)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <a
                style="
                  margin: 5px;
                  padding: 10px;
                  background: #7bc32e;
                  color: rgb(255 237 141);
                  text-decoration: none;
                  border-radius: 5px;
                  cursor: pointer;
                  display: inline-block;
                "
                target="_blank"
                [href]="item.uniformResourceLocatorUrl"
              >
                {{ item.uniformResourceLocatorUrl || "-" }}
              </a>
              <!-- <p>
                {{ item.uniformResourceLocatorUrl || "-" }}
              </p> -->
            </div>
            <div
              *ngIf="
                displayMap['chemroboticsLitigationNumberCrln'] &&
                item.chemroboticsLitigationNumberCrln
              "
              class="product-info2"
            >
              <h6>
                chemrobotics litigation number crln
                <button
                  class="copy-btn"
                  *ngIf="item.chemroboticsLitigationNumberCrln"
                  (click)="
                    copyToClipboard(item.chemroboticsLitigationNumberCrln)
                  "
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.chemroboticsLitigationNumberCrln }}
              </p>
            </div>
            <div
              *ngIf="displayMap['patentNumbers'] && item.patentNumbers"
              class="product-info2"
            >
              <h6>
                patent numbers
                <button
                  class="copy-btn"
                  *ngIf="item.patentNumbers"
                  (click)="copyToClipboard(item.patentNumbers)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.patentNumbers }}
              </p>
            </div>
            <div
              *ngIf="displayMap['patentType'] && item.patentType"
              class="product-info2"
            >
              <h6>
                patent type
                <button
                  class="copy-btn"
                  *ngIf="item.patentType"
                  (click)="copyToClipboard(item.patentType)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.patentType }}
              </p>
            </div>
            <div
              *ngIf="
                displayMap['innovatorsPatentOrangeBookListed'] &&
                item.innovatorsPatentOrangeBookListed
              "
              class="product-info2"
            >
              <h6>
                innovators patent orange book listed
                <button
                  class="copy-btn"
                  *ngIf="item.innovatorsPatentOrangeBookListed"
                  (click)="
                    copyToClipboard(item.innovatorsPatentOrangeBookListed)
                  "
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.innovatorsPatentOrangeBookListed }}
              </p>
            </div>
            <div
              *ngIf="
                displayMap['legalProceedingType'] && item.legalProceedingType
              "
              class="product-info2"
            >
              <h6>
                legal proceeding type
                <button
                  class="copy-btn"
                  *ngIf="item.name"
                  (click)="copyToClipboard(item.legalProceedingType)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.legalProceedingType }}
              </p>
            </div>

            <div
              *ngIf="displayMap['caseNumber'] && item.caseNumber"
              class="product-info2"
            >
              <h6>
                case number
                <button
                  class="copy-btn"
                  *ngIf="item.caseNumber"
                  (click)="copyToClipboard(item.caseNumber)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.caseNumber }}
              </p>
            </div>

            <div
              *ngIf="
                displayMap['plaintiffsRepresentative'] &&
                item.plaintiffsRepresentative
              "
              class="product-info2"
            >
              <h6>
                plaintiffs representative
                <button
                  class="copy-btn"
                  *ngIf="item.plaintiffsRepresentative"
                  (click)="copyToClipboard(item.plaintiffsRepresentative)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.plaintiffsRepresentative }}
              </p>
            </div>

            <div
              *ngIf="
                displayMap['defendantsRepresentative'] &&
                item.defendantsRepresentative
              "
              class="product-info2"
            >
              <h6>
                defendants representative
                <button
                  class="copy-btn"
                  *ngIf="item.defendantsRepresentative"
                  (click)="copyToClipboard(item.defendantsRepresentative)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.defendantsRepresentative }}
              </p>
            </div>

            <div
              *ngIf="
                displayMap['jurisdictionPatentOffice'] &&
                item.jurisdictionPatentOffice
              "
              class="product-info2"
            >
              <h6>
                jurisdiction patent office
                <button
                  class="copy-btn"
                  *ngIf="item.jurisdictionPatentOffice"
                  (click)="copyToClipboard(item.jurisdictionPatentOffice)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.jurisdictionPatentOffice }}
              </p>
            </div>
            <div
              *ngIf="
                displayMap['benchTrialJuryTrialExaminers'] &&
                item.benchTrialJuryTrialExaminers
              "
              class="product-info2"
            >
              <h6>
                bench trial jury trial examiners
                <button
                  class="copy-btn"
                  *ngIf="item.benchTrialJuryTrialExaminers"
                  (click)="copyToClipboard(item.benchTrialJuryTrialExaminers)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.benchTrialJuryTrialExaminers }}
              </p>
            </div>
            <div
              *ngIf="
                displayMap['priorArtCitedByDefendant'] &&
                item.priorArtCitedByDefendant
              "
              class="product-info2"
            >
              <h6>
                prior art cited by defendant
                <button
                  class="copy-btn"
                  *ngIf="item.priorArtCitedByDefendant"
                  (click)="copyToClipboard(item.priorArtCitedByDefendant)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.priorArtCitedByDefendant }}
              </p>
            </div>

            <div
              *ngIf="
                displayMap['priorArtCitedByDefendant'] &&
                item.priorArtCitedByOthers
              "
              class="product-info2"
            >
              <h6>
                prior art cited by others
                <button
                  class="copy-btn"
                  *ngIf="item.priorArtCitedByOthers"
                  (click)="copyToClipboard(item.priorArtCitedByOthers)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.priorArtCitedByOthers }}
              </p>
            </div>
            <div
              *ngIf="displayMap['technicalField'] && item.technicalField"
              class="product-info2"
            >
              <h6>
                technical field
                <button
                  class="copy-btn"
                  *ngIf="item.technicalField"
                  (click)="copyToClipboard(item.technicalField)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.technicalField }}
              </p>
            </div>
            <div
              *ngIf="
                displayMap['digitalObjectIdentifierDoi'] &&
                item.digitalObjectIdentifierDoi
              "
              class="product-info2"
            >
              <h6>
                digital object identifier doi
                <button
                  class="copy-btn"
                  *ngIf="item.digitalObjectIdentifierDoi"
                  (click)="copyToClipboard(item.digitalObjectIdentifierDoi)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.digitalObjectIdentifierDoi }}
              </p>
            </div>
            <div
              *ngIf="displayMap['caseCopy'] && item.caseCopy"
              class="product-info2"
            >
              <h6>
                case copy
                <button
                  class="copy-btn"
                  *ngIf="item.caseCopy"
                  (click)="copyToClipboard(item.caseCopy)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.caseCopy }}
              </p>
            </div>
            <div
              *ngIf="displayMap['decision'] && item.decision"
              class="product-info2"
            >
              <h6>
                decision
                <button
                  class="copy-btn"
                  *ngIf="item.decision"
                  (click)="copyToClipboard(item.decision)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.decision }}
              </p>
            </div>
            <div
              *ngIf="displayMap['appeal'] && item.appeal"
              class="product-info2"
            >
              <h6>
                appeal
                <button
                  class="copy-btn"
                  *ngIf="item.appeal"
                  (click)="copyToClipboard(item.appeal)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.appeal }}
              </p>
            </div>
            <div
              *ngIf="displayMap['miscellaneous'] && item.miscellaneous"
              class="product-info2"
            >
              <h6>
                miscellaneous
                <button
                  class="copy-btn"
                  *ngIf="item.miscellaneous"
                  (click)="copyToClipboard(item.miscellaneous)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.miscellaneous }}
              </p>
            </div>
            <div
              *ngIf="displayMap['notes'] && item.notes"
              class="product-info2"
            >
              <h6>
                notes
                <button
                  class="copy-btn"
                  *ngIf="item.notes"
                  (click)="copyToClipboard(item.notes)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.notes }}
              </p>
            </div>
            <div
              *ngIf="displayMap['remarks'] && item.remarks"
              class="product-info2"
            >
              <h6>
                remarks
                <button
                  class="copy-btn"
                  *ngIf="item.remarks"
                  (click)="copyToClipboard(item.remarks)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.remarks }}
              </p>
            </div>
            <div
              *ngIf="displayMap['comments'] && item.comments"
              class="product-info2"
            >
              <h6>
                comments
                <button
                  class="copy-btn"
                  *ngIf="item.comments"
                  (click)="copyToClipboard(item.comments)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.comments }}
              </p>
            </div>
            <div
              *ngIf="displayMap['documents'] && item.documents"
              class="product-info2"
            >
              <h6>
                documents
                <button
                  class="copy-btn"
                  *ngIf="item.documents"
                  (click)="copyToClipboard(item.documents)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.documents }}
              </p>
            </div>
          </div>
        </div>
        <br />

        <!-- Additional Product Details -->
        <div class="product-additional-details">
          <div class="section-wrapper" id="description">
            <hr class="section-divider" />
            <h2 class="section-title">
              description
              <!-- <button
              class="copy-btn"
              *ngIf="item.description"
              (click)="copyToClipboard(item.description)"
              pTooltip="Copy to clipboard"
              tooltipPosition="top"
              style="color: #ffe16a"
            >
              <i class="pi pi-copy"></i>
            </button> -->
            </h2>
            <!-- <p>
            {{ item.description }}
          </p> -->
            <div class="product-detail" style="margin-top: 20px">
              <div class="grid grid-cols gap-4">
                <div
                  *ngIf="displayMap['description'] && item.description"
                  class="product-info"
                >
                  <h6>
                    description
                    <button
                      class="copy-btn"
                      *ngIf="item.description"
                      (click)="copyToClipboard(item.description)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{
                      expandedCards[i] ||
                      item.description.length <= descriptionLimit
                        ? item.description
                        : (item.description | slice : 0 : descriptionLimit) +
                          "..."
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="
              item.DUMMY1 ||
              item.DUMMY2 ||
              item.DUMMY3 ||
              item.DUMMY4 ||
              item.DUMMY5 ||
              item.DUMMY6 ||
              item.DUMMY7 ||
              item.DUMMY8 ||
              item.DUMMY9 ||
              item.DUMMY10 ||
              item.DUMMY11 ||
              item.DUMMY12 ||
              item.DUMMY13 ||
              item.DUMMY14
            "
            class="section-wrapper"
            id="dummy"
          >
            <hr class="section-divider" />
            <h2 class="section-title">DUMMY</h2>
            <div class="product-details" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-2">
                <div
                  *ngIf="displayMap['DUMMY1'] && item.DUMMY1"
                  class="product-info"
                >
                  <h6>
                    DUMMY 1
                    <button
                      class="copy-btn"
                      *ngIf="item.DUMMY1"
                      (click)="copyToClipboard(item.DUMMY1)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.DUMMY1 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.DUMMY1 || '-')"></p> -->
                </div>

                <div
                  *ngIf="displayMap['DUMMY2'] && item.DUMMY2"
                  class="product-info"
                >
                  <h6>
                    DUMMY 2
                    <button
                      class="copy-btn"
                      *ngIf="item.DUMMY2"
                      (click)="copyToClipboard(item.DUMMY2)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.DUMMY2 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.DUMMY2 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['DUMMY3'] && item.DUMMY3"
                  class="product-info"
                >
                  <h6>
                    DUMMY 3
                    <button
                      class="copy-btn"
                      *ngIf="item.DUMMY3"
                      (click)="copyToClipboard(item.DUMMY3)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.DUMMY3 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.DUMMY3 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['DUMMY4'] && item.DUMMY4"
                  class="product-info"
                >
                  <h6>
                    DUMMY 4
                    <button
                      class="copy-btn"
                      *ngIf="item.DUMMY4"
                      (click)="copyToClipboard(item.DUMMY4)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.DUMMY4 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.DUMMY4 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['DUMMY5'] && item.DUMMY5"
                  class="product-info"
                >
                  <h6>
                    DUMMY 5
                    <button
                      class="copy-btn"
                      *ngIf="item.DUMMY5"
                      (click)="copyToClipboard(item.DUMMY5)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.DUMMY5 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.DUMMY5 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['DUMMY6'] && item.DUMMY6"
                  class="product-info"
                >
                  <h6>
                    DUMMY 6
                    <button
                      class="copy-btn"
                      *ngIf="item.DUMMY6"
                      (click)="copyToClipboard(item.DUMMY6)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.DUMMY6 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.DUMMY6 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['DUMMY7'] && item.DUMMY7"
                  class="product-info"
                >
                  <h6>
                    DUMMY 7
                    <button
                      class="copy-btn"
                      *ngIf="item.DUMMY7"
                      (click)="copyToClipboard(item.DUMMY7)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.DUMMY7 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.DUMMY7 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['DUMMY8'] && item.DUMMY8"
                  class="product-info"
                >
                  <h6>
                    DUMMY 8
                    <button
                      class="copy-btn"
                      *ngIf="item.DUMMY1"
                      (click)="copyToClipboard(item.DUMMY1)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.DUMMY8 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.DUMMY8 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['DUMMY9'] && item.DUMMY9"
                  class="product-info"
                >
                  <h6>
                    DUMMY 9
                    <button
                      class="copy-btn"
                      *ngIf="item.DUMMY9"
                      (click)="copyToClipboard(item.DUMMY9)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.DUMMY9 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.DUMMY9 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['DUMMY10'] && item.DUMMY10"
                  class="product-info"
                >
                  <h6>
                    DUMMY 10
                    <button
                      class="copy-btn"
                      *ngIf="item.DUMMY10"
                      (click)="copyToClipboard(item.DUMMY10)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.DUMMY10 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.DUMMY10 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['DUMMY11'] && item.DUMMY11"
                  class="product-info"
                >
                  <h6>
                    DUMMY 11
                    <button
                      class="copy-btn"
                      *ngIf="item.DUMMY11"
                      (click)="copyToClipboard(item.DUMMY11)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.DUMMY11 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.DUMMY11 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['DUMMY12'] && item.DUMMY12"
                  class="product-info"
                >
                  <h6>
                    DUMMY 12
                    <button
                      class="copy-btn"
                      *ngIf="item.DUMMY12"
                      (click)="copyToClipboard(item.DUMMY12)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.DUMMY12 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.DUMMY12 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['DUMMY13'] && item.DUMMY13"
                  class="product-info"
                >
                  <h6>
                    DUMMY 13
                    <button
                      class="copy-btn"
                      *ngIf="item.DUMMY13"
                      (click)="copyToClipboard(item.DUMMY13)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.DUMMY13 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.DUMMY13 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['DUMMY14'] && item.DUMMY14"
                  class="product-info"
                >
                  <h6>
                    DUMMY 14
                    <button
                      class="copy-btn"
                      *ngIf="item.DUMMY14"
                      (click)="copyToClipboard(item.DUMMY14)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.DUMMY14 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.DUMMY14 || '-')"></p> -->
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>
        </div>
      </section>
      <button
        class="read-more-btn"
        *ngIf="hasExpandableContent(item)"
        (click)="toggleCard(i)"
      >
        {{ expandedCards[i] ? "Read Less" : "Read More" }}
      </button>
    </div>

    <!-- Sidebar -->
    <aside class="sidebar" *ngIf="i == 0">
      <div
        style="
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: space-between;
        "
      >
        <!-- Left side: Total Records -->
        <div style="width: 50%">
          <strong
            style="
              background: #7bc32e;
              color: #ffed8d;
              font-size: 16px;
              font-weight: 700;
              padding: 11px 15px;
              border-radius: 12px;
              box-shadow: 0 2px 4px #0003;
              white-space: nowrap;
              display: block;
              width: fit-content;
            "
          >
            Total Records: {{ totalRecords }}
          </strong>
        </div>

        <!-- Right side: Buttons -->
        <div
          style="
            width: 50%;
            display: flex;
            justify-content: flex-end;
            margin-left: 50px;
          "
        >
          <button
            style="
              background-color: #ffcd04;
              padding: 8px;
              border: none;
              border-radius: 6px;
              cursor: pointer;
              margin-right: 10px;
            "
            (click)="exportExcel('csv')"
          >
            <img src="../../../../assets/icons/download.png" />
            <span style="font-size: 12px; color: #000">CSV</span>
          </button>
          <button
            style="
              background-color: #ffcd04;
              padding: 8px;
              border: none;
              border-radius: 6px;
              cursor: pointer;
            "
            (click)="exportExcel('xlsx')"
          >
            <img src="../../../../assets/icons/download.png" />
            <span style="font-size: 12px; color: #000">XLS</span>
          </button>
        </div>
      </div>

      <h3 class="sidebar-title">
        Filters
        <button class="sidebar-toggle" (click)="toggleSidebar()">
          <span *ngIf="!isSidebarOpen">☰</span>
          <span *ngIf="isSidebarOpen">×</span>
        </button>
      </h3>

      <ul [class.active]="isSidebarOpen">
        <li>
          <label for="categoryFilter">COUNTRY</label>
          <p-dropdown
            [options]="countryOptions"
            [filter]="true"
            filterPlaceholder="Search Country"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.country"
            (onChange)="createFilter('country', $event.value)"
            placeholder="Select Country"
          ></p-dropdown>
        </li>

        <!-- 
        <li>
          <label for="categoryFilter">PATENT TYPE</label>
          <p-dropdown
            [options]="patentTypeOptions"
            [filter]="true"
            filterPlaceholder="Search Patent Type "
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.patentType"
            (onChange)="createFilter('patentType', $event.value)"
            placeholder="Select Patent Type "
          ></p-dropdown>
        </li>

        <li>
          <label for="categoryFilter">ASSIGNEE</label>
          <p-dropdown
            [options]="assigneeOptions"
            [filter]="true"
            filterPlaceholder="Search Assignee"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.assignee"
            (onChange)="createFilter('assignee', $event.value)"
            placeholder="Select Assignee"
          ></p-dropdown>
        </li> -->

        <!-- <li>
          <label for="categoryFilter">APPLICATION OF INTER</label>
          <p-dropdown
            [options]="PlatformFliters.activeIngredient"
            [filter]="true"
            filterPlaceholder="Search Application Of Inter"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.activeIngredient"
            (onChange)="createFilter('activeIngredient', $event.value)"
            placeholder="Select Application Of Inter"
          ></p-dropdown>
        </li> -->

        <!-- <li>
          <label for="categoryFilter">FEILD OF APPLICATION</label>
          <p-dropdown
            [options]="PlatformFliters.fieldOfApplication"
            [filter]="true"
            filterPlaceholder="Search Feild Of Application"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.fieldOfApplication"
            (onChange)="createFilter('fieldOfApplication', $event.value)"
            placeholder="Select Feild Of Application"
          ></p-dropdown>
        </li> -->

        <!-- <li>
          <label for="colorFilter">ORDER</label>

          <p-dropdown
            [options]="sortByOptions"
            [filter]="true"
            filterPlaceholder="Search Order"
            filterBy="name"
            class="w-full custom-dropdown"
            [(ngModel)]="sortBy"
            (onChange)="applyFilter()"
            optionLabel="name"
            optionValue="code"
            placeholder="Select Order"
          >
          </p-dropdown>
        </li> -->
        <!-- <li>
          <label for="categoryFilter">UPDATION DATE</label>
          <p-dropdown
            [options]="PlatformFliters.updationDate"
            [filter]="true"
            filterPlaceholder="Search Updation Date"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.updationDate"
            (onChange)="createFilter('updationDate', $event.value)"
            placeholder="Select Updation Date"
          ></p-dropdown>
        </li> -->
      </ul>
      <div class="filter-buttons">
        <button (click)="applyFilter()">Apply Filter</button>
        <button (click)="resetFilter()">Reset Filter</button>
      </div>
    </aside>
  </div>

  <div class="pagination-container">
    <p-paginator
      (onPageChange)="onPageChange($event)"
      [first]="first"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [styleClass]="'custom-paginator'"
    >
    </p-paginator>

    <p class="total-pages" *ngIf="totalpages > 2">
      Total Pages: <span>{{ totalpages }}</span>
    </p>
  </div>
  <button class="back_to_top my-5" (click)="scrollToTop()">
    <img
      class="back_to_top_img"
      src="../../../assets/icons/output-onlinepngtools (5).png"
    />
  </button>
</div>
<ng-template #noResultsFound>
  <div class="no-results-container" *ngIf="searched">
    <img
      src="../../../assets/img/no-data.png"
      class="no-results-image"
      alt="No data available"
    />
    <div class="no-results-message color_black">
      <span class="font_20 weight_800"
        >Sorry – The search found zero results. Why…</span
      >
      <ul class="no-results-list text_start">
        <li>
          <span class="font_20 weight_500"
            >Make sure you have selected the correct search criteria</span
          >
        </li>
        <li>
          <span class="font_20 weight_500"
            >Make sure that all words are spelled correctly</span
          >
        </li>
        <li>
          <span class="font_20 weight_500">Try different keywords</span>
        </li>
        <li>
          <span class="font_20 weight_500">Try more general keywords</span>
        </li>
      </ul>
    </div>
    <!-- Back to search button -->
    <!-- <button class="btn-back-to-search" (click)="goBackToSearch()">
      Back to Search
    </button> -->
  </div>
</ng-template>
